<template>
  <p class="has-text-centered spinner">
    <img alt="Fetching..." src="/static/img/others/spinner.svg"/>
  </p>
</template>

<script>
export default {
  name: 'Loader'
}
</script>



// WEBPACK FOOTER //
// src/components/Loader.vue